import { FC } from "react";
import { useTheme } from "styled-components";
import {
  HeaderThreeList,
  WrapperHeaderThree,
} from "componentLayout/Header/HeaderThree/HeaderThreeDesktop/styled.styles";
import {
  OtherCategories,
  LevelThreeMenuItem,
} from "componentLayout/Header/HeaderThree/HeaderThreeDesktop/Menus";

const HeaderThreeDesktop: FC = () => {
  const {megaMenu = { otherMenuItems: [], level3MenuItems: {}, level1MenuItems: {} }} = useTheme();
  const { level3MenuItems, otherMenuItems } = megaMenu || {};
  return (
    <WrapperHeaderThree id="headerThreeDesktop">
      <HeaderThreeList className="flex flexSpaceBetween m-auto width-1200">
        <LevelThreeMenuItem category={level3MenuItems?.Autos} />
        <LevelThreeMenuItem category={level3MenuItems?.realEstates} />
        <LevelThreeMenuItem category={level3MenuItems?.MobileTablet} />
        <LevelThreeMenuItem category={level3MenuItems?.Gaming} />
        <LevelThreeMenuItem category={level3MenuItems?.HomeAndFurniture} />
        <LevelThreeMenuItem
          category={level3MenuItems?.JobsVertical}
          className="lastTwoMenus"
        />
        <OtherCategories
          mainCategories={otherMenuItems}
          className="lastTwoMenus"
        />
      </HeaderThreeList>
    </WrapperHeaderThree>
  );
};

export default HeaderThreeDesktop;
